(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dreame-service-center-tabs"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){  
  $(".service-center-tabs-list li span").click(function(){
      var tabId = $(this).attr('data-id');  
      $(".service-center-tabs-list li").removeClass("active");
      $(this).parent("li").addClass("active");
      $(".common-service-content").hide();                                                       
      $('#'+tabId).show();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text-grid-layout"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Load YouTube API
  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);

  let ytPlayers = [];

  window.onYouTubeIframeAPIReady = function () {
    document.querySelectorAll(".yt-video").forEach((iframe, index) => {
      ytPlayers[index] = new YT.Player(iframe, {
        events: {
          'onStateChange': function (event) {
            let wrapper = iframe.closest(".video-wrapper");
            let playBtn = wrapper.querySelector(".play-btn");

            // -1 = unstarted, 0 = ended, 1 = playing, 2 = paused
            if (event.data === YT.PlayerState.PLAYING) {
              playBtn.style.display = "none";
            } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
              playBtn.style.display = "block";
            }
          }
        }
      });
    });
  };

  // Play button functionality
  document.querySelectorAll(".play-btn").forEach((button, index) => {
    button.addEventListener("click", function () {
      let wrapper = button.closest(".video-wrapper");
      let poster = wrapper.querySelector(".video-poster");
      let iframe = wrapper.querySelector(".yt-video");
      let mp4 = wrapper.querySelector(".mp4-video");

      // Hide poster + button
      if (poster) poster.style.display = "none";
      button.style.display = "none";

      if (iframe) {
        iframe.classList.remove("hidden");
        if (ytPlayers[index]) {
          ytPlayers[index].playVideo();
        }
      }
      if (mp4) {
        mp4.classList.remove("hidden");
        mp4.play();

        // MP4 listeners
        mp4.addEventListener("pause", () => {
          button.style.display = "block";
        });
        mp4.addEventListener("ended", () => {
          button.style.display = "block";
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

const videoSwiper = new Swiper(".videoTextSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: false,

  // Default pagination (desktop/tablet)
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // Override settings for smaller screens
  breakpoints: {
    767: {
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",   // Show fraction pagination on mobile
      }
    },
    2000: {
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    },
  }
});
  // Load YouTube API
  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);

  let ytPlayers = [];

  window.onYouTubeIframeAPIReady = function () {
    document.querySelectorAll(".yt-video").forEach((iframe, index) => {
      ytPlayers[index] = new YT.Player(iframe, {
        events: {
          'onStateChange': function (event) {
            let wrapper = iframe.closest(".video-wrapper");
            let playBtn = wrapper.querySelector(".play-btn");

            // -1 = unstarted, 0 = ended, 1 = playing, 2 = paused
            if (event.data === YT.PlayerState.PLAYING) {
              playBtn.style.display = "none";
            } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
              playBtn.style.display = "block";
            }
          }
        }
      });
    });
  };

  // Play button functionality
  document.querySelectorAll(".play-btn").forEach((button, index) => {
    button.addEventListener("click", function () {
      let wrapper = button.closest(".video-wrapper");
      let poster = wrapper.querySelector(".video-poster");
      let iframe = wrapper.querySelector(".yt-video");
      let mp4 = wrapper.querySelector(".mp4-video");

      // Hide poster + button
      if (poster) poster.style.display = "none";
      button.style.display = "none";

      if (iframe) {
        iframe.classList.remove("hidden");
        if (ytPlayers[index]) {
          ytPlayers[index].playVideo();
        }
      }
      if (mp4) {
        mp4.classList.remove("hidden");
        mp4.play();

        // MP4 listeners
        mp4.addEventListener("pause", () => {
          button.style.display = "block";
        });
        mp4.addEventListener("ended", () => {
          button.style.display = "block";
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
